export const TEXT = {
    hello: 'hello',
    welcome_to_iclass: 'welcome_to_iclass',
    login_as_student: 'login_as_student',
    login_as_teacher: 'login_as_teacher',
    username: 'username',
    class_code: 'class_code',
    access_code: 'access_code',
    login: 'login',
    logout: 'logout',
    logout_confirm: 'sure_that_you_want_to_logout',
    yes: 'yes',
    loading: 'loading',
    student: 'student',
    student_name: 'student_name',
    students: 'student',
    teacher: 'teacher',
    teacher_assistant: 'teaching_assistant',
    ac_ao: 'AC/AO',
    today_schedule: 'today_schedule',
    content: 'content',
    schedule: 'schedule',
    no_class_today: 'there_are_no_classes_found',
    not_started: 'not_started',
    on_going: 'on_going',
    finished: 'iclass_finished',
    teaching: 'teaching',
    management: 'management',
    start: 'start',
    start_iclass: 'start_iClass',
    are_you_sure_to_start_class: 'sure_to_start_the_class',
    student_joined_in_class: 'number_student_join',
    no_student_joined: 'no_student_joined',
    no_student_joined_desc: 'no_students_in_the_class',
    no_lesson_content: 'no_lesson_content',
    no_lesson_content_desc: 'the_class_cannot_be_started',
    back_to_schedule: 'back_to_schedule',
    group: 'group',
    groups: 'groups',
    student_group: 'student_group',
    let_s_choose_a_group: 'choose_a_group',
    you_have_joined_group: 'join_group_successful',
    confirm: 'confirm',
    submit_vocab: 'submit_vocab',
    add_student_group: 'add_student',
    change_student_group: 'change_group',
    student_request: 'student_request',
    request: 'request',
    request_to_join: 'request_join_class',
    request_to_join_not_sent: 'confirm_join_class_text',
    request_to_join_sent: 'request_sent_text',
    send_request: 'send_request',
    approve_join: 'Request approved',
    end_class: 'end_class',
    end_class_desc: 'class_log_out_all_student_accounts',
    end: 'end',
    class_has_ended: 'class_has_ended',
    class_has_ended_desc: 'system_ended_the_class',
    return_to_home: 'return_to_home_screen',
    signalr_connection_error: 'Hub connection error!',
    no_signalr_action_hander: 'No handler for ',
    settings: 'setting',
    raise_hand: 'raise_hand',
    lock_screen: 'lock_screen',
    unlock_screen: 'unlock_screen',
    lock_screen_message: 'lock_screen_text',
    teacher_locking_screen: 'locking_the_screen',
    vocab: 'vocabulary',
    lecture: 'presentation',
    practice: 'practice',
    workbook: 'workbook',
    quiz: 'quiz',
    summary: 'Summary',
    reward_point: 'reward_point',
    reward_point_for_session: 'reward_point_for_session',
    reward_point_for_group: 'reward_point_for_group',
    points: 'points',
    current_point: 'current_point',
    force_screen: 'force_screen',
    unforce_screen: 'unforce_screen',
    point_student_total: 'individual_score',
    point_group: 'accumulated_score',
    point_group_total: 'group_score',
    record: 'record',
    teacher_forced_screen: 'switched_to_the_section',
    practice_completed: 'practice_completed',
    correct_answer: 'correct_answer',
    wait_teacher_start_practice: 'practice_not_start_text',
    start_practice: 'start_practice',
    practice_in_progress: 'practice_is_in_progress',
    no_sound_detected: "no_sound_detected",
    the_sound_not_match: "the_sound_not_match",
    result: 'result',
    sound: 'sound',
    feedback: 'feedback',
    pronunciation_result: 'pronunciation_result',
    score: 'score',
    attempts_remaining: 'attempts_remaining',
    tap_the_record_button_to_start: 'tap_the_record_button',
    listening: 'listening',
    retry: 'retry',
    recording_ended: 'recording_ended',
    wait_teacher_start_quiz: 'start_quiz_text',
    instruction: 'instruction',
    quiz_instruction: 'enter_the_lesson_link_into_the_quiz',
    supported_systems: 'supported_systems',
    quiz_supported_systems: 'quizizz',
    enter_student_quiz_link: 'enter_student_quiz_link',
    save: 'save',
    quiz_updated: 'updated',
    hide_quiz: 'hide_quiz',
    show_quiz: 'show_quiz',
    video: 'video',
    question_list: 'question_list',
    no_lecture_available: 'no_lecture_videos_available',
    lecture_updated: 'updated',
    question: 'question',
    leaderboard: 'leaderboard',
    rank: 'rank',
    pts: 'pts',
    student_disconnected: 'student_disconnected',
    example: 'example',
    allow_speaking: 'allow_speaking',
    follow_teacher_screen: 'follow_teacher_screen',
    stop_all: 'stop_all',
    apply: 'apply',
    no_mic_found: 'no_micro_found',
    you_can_now_record_your_speaking: 'record_your_speaking',
    congratulations_on_increasing_score: 'increase_score',
    student_point_change_desc: 'point_session_score',
    group_point_change_desc: 'point_accumulated_score',
    sorry_your_score_has_decreased: 'decrease_score',
    personal_ranking: 'personal_ranking',
    group_ranking: 'group_ranking',
    no_ranking: 'no_ranking',
    attention_please: 'attention_please',
    the_allocated_time_for_the_class_has_ended: 'allocated_time_for_the_class_has_ended',
    the_class_will_automatically_close_at: 'class_close',
    select_all: 'select_all',
    copyright: 'copy_right_iclass',
    student_point_change_noti: 'point_student_name',
    group_point_change_noti: 'point_group_name',
    sign_in_with_google: 'sign_in_with_google',
    login_failed: 'login_failed',
    network_error: 'network_error',
    correct: 'vocab_result_correct',
    incorrect: 'vocab_result_incorrect',
    unanswered: 'unanswered',
    warning: 'vocab_result_warning',
    increase_reward_point_text: 'increase_reward_point_text',
    decrease_reward_point_text: 'decrease_reward_point_text',
    increase_group_point_text: 'increase_group_point_text',
    decrease_group_point_text: 'decrease_group_point_text',
    your_record: 'your_record',
    next_question: 'Next question',
    prev_question: 'Previous question',
    submission: 'submission',
    choose_one_correct_answer: 'Choose one correct answer',
    choose_the_correct_answers: 'Choose the correct answers',
    fill_in_the_blank: 'Fill in the blank',
    submit: 'Submit',
    submitted: 'submitted',
    number_of_questions: 'number_of_question',
    correct_question: 'correct_question',
    your_point: 'your_point',
    questions: 'questions',
    close: 'close',
    corrected: 'correct',
    incorrected: 'incorrect',
    almost_corrected: 'almost_correct',
    hide_answer: 'hide_answer_btn',
    show_answer: 'show_answer_btn',
    student_view_answer: 'student_view_answer_toggle',
    quiz_total_point: 'quiz_total_point',
    quiz_total_time: 'quiz_total_time',
    quiz_online: 'quiz_online',
    preview_quiz_btn: 'preview_quiz_btn',
    show_correct_answer_toggle: 'show_correct_answer_toggle',
    finish_quiz: 'finish_quiz',
    count_finish_quiz: 'count_finish_quiz',
    finish_quiz_text: 'finish_quiz_text',
    count_change_question: 'count_change_question',
    change_question_text: 'change_question_text',
    confirm_popup_btn: 'confirm_popup_btn',
    cancel_popup_btn: 'cancel_popup_btn',
    next_btn: 'next_btn',
    end_quiz_btn: 'end_quiz_btn',
    close_btn: 'close_btn',
    quiz_top_score: 'quiz_top_score',
    view_ranking_btn: 'view_ranking_btn',
    view_answer_btn: 'view_answer_btn',
    final_result_quiz_text_1: 'final_result_quiz_text_1',
    final_result_quiz_text_2: 'final_result_quiz_text_2',
    count_start_quiz: 'count_start_quiz',
    count_finish_question: 'count_finish_question',
    start_quiz_btn: 'start_quiz_btn',
    submit_btn: 'submit_btn',
    top: 'top',
    time: 'time',
    quiz_point: 'quiz_point',
    ranking: 'ranking',
    your_result: 'your_result',
    quiz_number_question: 'quiz_number_question',
    quiz_ranking: 'quiz_ranking',
    change_question: 'change_question',
    view_submission_quiz_toggle: 'view_submission_quiz_toggle',
    explanation: 'explanation',
    finish_quiz_student: 'finish_quiz_student',
    finish_quiz_teacher: 'finish_quiz_teacher',

}